module.exports = __webpack_public_path__ + "img/drivingLicensePic.32eaa25b.png";